// extracted by mini-css-extract-plugin
module.exports = {"toggleSwitch":"toggle_toggleSwitch__1sv_r","slider":"toggle_slider__wz8OU","round":"toggle_round__66V3b"};